import React from "react";

const SelectionField = ({
  selectedAccountType,
  setSelectedAccountType,
  selectionType,
  rightIcon,
  text,
  ...props
}) => {
  const isSelected = selectedAccountType === selectionType;
  return (
    <div
      className={`${
        isSelected ? "selected-account-type" : "unselected-account-type"
      } account-selection-field d-flex justify-content-start align-items-center p-2 my-4 position-relative`}
      onClick={() => {
        setSelectedAccountType(selectionType);
      }}
    >
      <p className="my-auto text-md-start text-center">{text}</p>
      {isSelected && (
        <img
          src={rightIcon ?? "/images/simpleTick.svg"}
          className="position-absolute tick-icon"
          alt="img"
        />
      )}
    </div>
  );
};

export default SelectionField;
